<template lang="pug">
  .column(data-cy="signin-methods")
    h3 Welcome
    p.u-text-lg.u-mb-sm One account gets you into everything baianat offers.
    ValidationObserver(v-slot="{ validate }" ref="form")
      form(@submit.prevent="validate().then(waitForCode ? confirmSMS : onSubmit)")
        component(
          :is="isEmail ? 'TextInput' : 'PhoneInput'"
          v-if="!waitForCode"
          name="email"
          :autofocus="true"
          type="text"
          :label="isEmail ? 'Email' : 'Phone'"
          v-model="input"
          rules="required"
        )
        p.u-mt-sm {{ isEmail ? 'Use Phone to login?' : 'Use Email to login?' }} #[a(href="#" @click.prevent="isEmail = !isEmail" class="u-super") Click here]

        TextInput(
          v-if="waitForCode"
          name="code"
          :autofocus="true"
          type="text"
          label="6-Digit code"
          v-model="code"
          rules="required|numeric|length:6"
        )

        button.button-link.is-medium(v-load="isSubmitting") Login

    p.u-mt-sm(v-if="!waitForCode") Already has code? #[a(href="#" @click.prevent="waitForCode = true" class="u-super") Verify Now]
    p.u-mt-sm(v-else) Didn't get anything? #[a(href="#" @click.prevent="waitForCode = false" class="u-super") Text me again]

</template>

<script>
import { ValidationObserver } from 'vee-validate';
import api from '@/api';
import TextInput from './TextInput';
import PhoneInput from './PhoneInput';
import {
  RequestEmailLoginToken,
  RequestSmsLoginToken,
  LoginWithSms
} from '@/graphql/Auth.gql';

export default {
  name: 'LoginForm',
  components: {
    TextInput,
    PhoneInput,
    ValidationObserver
  },
  data: () => ({
    isSubmitting: false,
    isEmail: true,
    input: '',
    waitForCode: false,
    code: ''
  }),
  watch: {
    isEmail () {
      this.input = '';
      requestAnimationFrame(() => {
        this.$refs.form.reset();
      });
    }
  },
  created () {
    if (process.server) return;

    const method = localStorage.getItem('loginMethod');
    if (method) {
      this.method = method;
      localStorage.removeItem('loginMethod');
    }
  },
  methods: {
    async onSubmit () {
      try {
        const isPhone = /^\+?[0-9]+$/.test(this.input);
        this.isSubmitting = true;
        const { data } = await api.mutate({
          mutation: isPhone ? RequestSmsLoginToken : RequestEmailLoginToken,
          variables: {
            input: {
              phone: isPhone ? this.input : undefined,
              email: isPhone ? undefined : this.input,
              app: isPhone ? 'BAIANAT_WEB' : undefined,
              callbackUrl: isPhone
                ? undefined
                : `https://accounts.baianat.com/auth/email/callback`
            }
          }
        });

        if (
          data[isPhone ? 'requestSmsLoginToken' : 'requestEmailLoginToken']
            .success &&
          isPhone
        ) {
          this.waitForCode = true;
          requestAnimationFrame(() => {
            this.$refs.form.reset();
            this.$notify('You should get a message shortly.', 'success');
          });
        }

        this.$notify('Magic link on its way', 'success');
      } catch (err) {
        this.$notify(err.message, 'error');
      } finally {
        this.isSubmitting = false;
      }
    },
    async confirmSMS () {
      try {
        this.isSubmitting = true;
        const { data } = await api.mutate({
          mutation: LoginWithSms,
          variables: {
            input: {
              phone: this.input,
              token: this.code
            }
          }
        });

        this.$emit('success', data.loginWithSms);
      } catch (err) {
        this.$notify(err.message, 'error');
      } finally {
        this.isSubmitting = false;
      }
    }
  }
};
</script>
